module.exports = __webpack_public_path__ + "img/commercial.bf4c1c15.jpg";